import React from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { loadLocation, clearLocation } from '../../common/locations/actions'
import { Title } from '../components'
import { LocationForm } from '../forms'

class LocationPage extends React.Component {
  componentDidMount() {
    const { match, loadLocation, location } = this.props
    const { params } = match
    if (params.location && (!location._id || params.location !== location._id)) {
      loadLocation(params.location)
    }
  }
  componentWillUnmount() {
    this.props.clearLocation()
  }
  render() {
    const { match, location } = this.props
    const { params } = match
    let locationForm = null
    if (params.location) {
      if (location._id) locationForm = <LocationForm location={location} />
    } else {
      locationForm = <LocationForm />
    }
    const title = location._id ? location.name : 'Nová lokace'
    return (
      <div>
        <Title message={title} />
        <aside className="breadcrumbs">
          <Link to="/locations">Lokace</Link>
          <img src="/images/arrow.png" alt="arrow-right" />
          <span>{title}</span>
        </aside>
        <main className="form-page thin">
          {locationForm}
        </main>
      </div>
    )
  }
}

LocationPage.propTypes = {
  match: React.PropTypes.object.isRequired,
  location: React.PropTypes.object.isRequired,
  loadLocation: React.PropTypes.func.isRequired,
  clearLocation: React.PropTypes.func.isRequired,
}

export default connect(state => ({
  location: state.locations.current,
}), { loadLocation, clearLocation })(LocationPage)



// WEBPACK FOOTER //
// ./src/browser/pages/Location.js